<template>
  <div>
    <v-simple-table class="borderless-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th>
              Description
            </th>
            <th>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in driverUploadedDocuments"
            :key="item"
            class="bg-white"
          >
            <td>{{ item.description }}</td>
            <td>
              <v-btn
                text
                class="blue--text"
                x-small
                @click="handleViewDocument(item.id)"
              >
                View
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import axios from 'axios'
import UploadDriverDocument from '../../components/document/UploadDriverDocument'

export default {
  name: "DriverUploadedDocuments",
  props: {
    driverUploadedDocuments: {
      default: null,
      type: Array
    }
  },
  data () {
    return {
      uploadDialog: false,
      selectedDocument: ""
    }
  },
  methods: {
    handleDeleteDocument: function (fileID) {
      console.log(fileID);
      this.currentDriverDocuments = this.driverUploadedDocuments.filter(
        function (document) {
          return document.id !== fileID;
        }
      );
    },
    handleViewDocument: function (fileID) {
      let documentFile = this.driverUploadedDocuments.find(function (document) {
        return document.id === fileID;
      });
    
      let self = this;
      let url = `${this.$store.state.apiUrl}/driver/getDocumentUrl`;
      axios({
        url: url,
        method: "GET",
        params: {
          key: documentFile.filename,
        },
      })
        .then(function (response) {
          if (response.data.error) {
            console.log(response.data.error);
            self.snackbarMessage = "Failed to retrieve file";
            self.snackbarColour = "error";
            self.snackbarShow = true;
          } else {
            const link = document.createElement("a");
            link.href = response.data.url;
            link.target = "_blank";
            link.setAttribute("download", documentFile.name);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(function (error) {
          console.log(error);
          self.snackbarMessage = "Failed to retrieve file";
          self.snackbarColour = "error";
          self.snackbarShow = true;
        });
    },
  }
}
</script>

<style >

.borderless-table table tr td,th {
  border: none !important;
}


</style>